import { every } from "lodash";
import { isReferralsAdminAndAbove } from "./checkRoles";
export default function canAccept(_ref) {
  var user = _ref.user,
    isCC = _ref.isCC,
    referral = _ref.referral,
    groupId = _ref.groupId;
  var referralState = referral.state,
    _referral$case = referral.case,
    caseOutcome = _referral$case.outcome,
    caseState = _referral$case.state;
  if (caseState === "draft") {
    return null;
  }
  var checks = [isReferralsAdminAndAbove(user, groupId), !isCC, ["sent", "in_review"].includes(referralState), caseOutcome === null, ["referred"].includes(caseState), referral.receiving_provider.id === groupId];
  return every(checks);
}
//# sourceMappingURL=canAccept.js.map